var map = {
	"./add.png": 52910,
	"./comment.png": 82544,
	"./copy.png": 60760,
	"./delete.png": 55068,
	"./deleteComment.png": 89553,
	"./disable.png": 18879,
	"./enable.png": 24722,
	"./paste.png": 56345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58978;